//@ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { Link, useMatch, useParams } from 'react-router-dom'
import { useAppDispatch } from '../../app/hooks';
import { fetchPipelineStagesList } from '../../features/skills/skillsSlice';
import { createAppScoreCardDataThunk } from '../../features/ApplicationData/ApplicationDataSlice';
import { Toaster, toast } from 'sonner';
import { fetchAppSkillRatingByDetails, updateAppSkillRating } from '../../features/AppSkillRating/AppSkillRatingSlice';
// Auto-resizing textarea component
const AutoResizeTextarea = ({ value, onChange, placeholder, isRequired, hasError }) => {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            // Reset height to auto to get the correct scrollHeight
            textareaRef.current.style.height = "auto";
            // Set the height based on scrollHeight with a minimum of 36px
            textareaRef.current.style.height = `${Math.max(36, textareaRef.current.scrollHeight)}px`;
        }
    }, [value]);

    return (
        <div className="w-full">
            <textarea
                ref={textareaRef}
                className={`outline-none bg-transparent focus:outline-none focus:ring-0 text-[14px] text-dark-black-100 w-full m-0 placeholder:text-[#9e9ea0]
        border-1 border-solid ${hasError ? 'border-red-500' : 'border-light-gray-200'} rounded-md p-2 min-h-[36px] overflow-hidden resize-none leading-5`}
                placeholder={`${placeholder}${isRequired ? ' *' : ''}`}
                value={value}
                onChange={onChange}
                rows={1}
                maxLength={1000}
            />
            {hasError && <p className="text-red-500 text-xs mt-[-2px]">This field is required</p>}
        </div>
    );
};

const AutoResizeTextarea1 = ({ value, onChange, placeholder, hasError }) => {
    const textareaRef = useRef(null);

    useEffect(() => {
        if (textareaRef.current) {
            // Reset height to auto to get the correct scrollHeight
            textareaRef.current.style.height = "auto";
            // Set the height based on scrollHeight with a minimum of 60px
            textareaRef.current.style.height = `${Math.max(60, textareaRef.current.scrollHeight)}px`;
        }
    }, [value]);

    return (
        <div className="w-full">
            <textarea
                ref={textareaRef}
                className={`outline-none bg-transparent focus:outline-none focus:ring-0 text-[14px] text-dark-black-100 w-full m-0 placeholder:text-[#9e9ea0]
        border-1 border-solid ${hasError ? 'border-red-500' : 'border-light-gray-200'} rounded-md p-2 min-h-[60px] overflow-hidden resize-none leading-5`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                rows={1}
                maxLength={1000}
            />
            {hasError && <p className="text-red-500 text-xs mt-1">This field is required</p>}
        </div>
    );
};

// Rating button component
const RatingButton = ({ label, value, selectedValue, onClick }) => {
    const isSelected = selectedValue === value;

    return (
        <button
            className={`flex items-center gap-[6px] text-[13px] rounded-md px-2 py-1 text-xs font-medium capitalize transition-colors ${isSelected
                ? 'bg-indigo-600 text-white ring-1 ring-inset ring-indigo-600'
                : 'bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10'
                }`}
            onClick={() => onClick(value)}
            type="button"
        >
            {label}
        </button>
    );
};

const RatingButton1 = ({ label, value, selectedValue, onClick }) => {
    const isSelected = selectedValue === value;

    return (
        <button
            className={`flex items-center gap-[6px] text-[13px] rounded-md px-2 py-1 text-xs font-medium capitalize transition-colors ${isSelected
                ? 'bg-indigo-600 text-white ring-1 ring-inset ring-indigo-600'
                : 'bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10'
                }`}
            onClick={() => onClick(value)}
            type="button"
        >
            {label}
        </button>
    );
};





function JobSkillScorecardEdit({ skillId }) {
    const { baseId, jobId, applicationId } = useParams<{ baseId: string; jobId: string; applicationId: string }>();
    const dispatch = useAppDispatch();
    const [dataLoading, setDataLoading] = useState(false);
    const [skills, setSkills] = useState([]);
    const [savingData, setSavingData] = useState(false);
    const [overallComment, setOverallComment] = useState("");
    const [overallCommentError, setOverallCommentError] = useState(false);
    const [overallRating, setOverallRating] = useState(null);
    const [overallRatingError, setOverallRatingError] = useState(false);

    // Store rating and comments for each skill
    const [skillsData, setSkillsData] = useState({});
    // Store validation errors
    const [validationErrors, setValidationErrors] = useState({});
    // Store which skills require comments
    const [commentRequiredSkills, setCommentRequiredSkills] = useState({});
    const scorecardMatch = useMatch(`/${baseId}/job/${jobId}/app/${applicationId}/scorecards/:skillId`);
    const skillId1 = scorecardMatch?.params?.skillId;
    const [appScorecardData, setAppScorecardData] = useState([])

    const [dataFetched, setDataFetched] = useState(false);

    useEffect(() => {
        const fetchSkills = async () => {
            if (!baseId || !appScorecardData?.scorecard?.id) return;

            setDataLoading(true);
            try {
                const response = await dispatch(
                    fetchPipelineStagesList({
                        baseId: Number(baseId),
                        userId: appScorecardData.scorecard.id,
                    })
                );

                if (response?.payload?.data) {
                    setSkills(response.payload.data);
                }
            } catch (error) {
                console.error("Error fetching skills:", error);
            } finally {
                setDataLoading(false);
            }
        };

        fetchSkills();
    }, [baseId, appScorecardData, dispatch]);


    // Handle rating selection
    const handleRatingSelect = (skillId, ratingValue) => {
        setSkillsData(prev => ({
            ...prev,
            [skillId]: {
                ...prev[skillId],
                rating: ratingValue
            }
        }));

        // Clear validation error for this skill's rating if it exists
        if (validationErrors[`rating_${skillId}`]) {
            setValidationErrors(prev => ({
                ...prev,
                [`rating_${skillId}`]: false
            }));
        }
    };

    // Handle comment changes
    const handleCommentChange = (skillId, commentText) => {
        setSkillsData(prev => ({
            ...prev,
            [skillId]: {
                ...prev[skillId],
                comment: commentText
            }
        }));

        // Clear validation error for this skill's comment if it exists
        if (validationErrors[`comment_${skillId}`]) {
            setValidationErrors(prev => ({
                ...prev,
                [`comment_${skillId}`]: false
            }));
        }
    };

    // Handle overall comment change
    const handleOverallCommentChange = (e) => {
        setOverallComment(e.target.value);
        if (overallCommentError) {
            setOverallCommentError(false);
        }
    };

    // Validate form before submission
    const validateForm = () => {
        const errors = {};
        let isValid = true;
        let overallCommentRequired = false;

        // Check if each skill has a rating
        skills.forEach(skill => {
            if (!skillsData[skill.id]?.rating) {
                errors[`rating_${skill.id}`] = true;
                isValid = false;
            }

            // Check if comment is required for this skill
            if (commentRequiredSkills[skill.id] && !skillsData[skill.id]?.comment.trim()) {
                errors[`comment_${skill.id}`] = true;
                isValid = false;
            }
        });

        // Check if overall rating is selected
        // if (!overallRating) {
        //     setOverallRatingError(true);
        //     isValid = false;
        // }

        // Check if overall comment is required
        if (overallCommentRequired && !overallComment.trim()) {
            setOverallCommentError(true);
            isValid = false;
        }

        setValidationErrors(errors);
        return isValid;
    };

    // Handle saving scorecard
    const handleSaveScorecard = async () => {
        // Validate form before submission
        if (!validateForm()) {
            toast.error("Please fill in all required fields.");
            return;
        }

        setSavingData(true);
        try {
            // Prepare skill ratings data for submission
            const skillRatings = Object.entries(skillsData).map(([skillId, data]) => ({
                skill_id: skillId,
                comment: data.comment || "",
                skill_scale: data.rating // 1-5 values as per the requirements
            }));
            // Prepare the payload according to the required format
            const payload = {
                app_id: applicationId,
                scorecard_id: skillId, // Assuming skillId is the scorecard_id
                comment: overallComment,
                // rating: overallRating,
                skill_rating: skillRatings
            };

            // Call the API to save scorecard data
            const response = await dispatch(updateAppSkillRating({
                baseId: Number(baseId),
                id: Number(skillId),
              
                data: payload
            }));

            if (response?.payload) {
                toast.success("App scorecard update successfully!");
            } else {
                // Handle API error
                if (response?.error?.message) {
                    toast.error(`Error: ${response.error.message}`);
                } else {
                    throw new Error("Failed to save app scorecard");
                }
            }
        } catch (error) {
            console.error("Error saving scorecard:", error);
            toast.error("Failed to save app scorecard. Please try again.");
        } finally {
            setSavingData(false);
        }
    };

    // Rating options mapping
    const ratingOptions = [
        { label: "Inadequate", value: 1 },
        { label: "Limited", value: 2 },
        { label: "Competent", value: 3 },
        { label: "Proficient", value: 4 },
        { label: "Expert", value: 5 }
    ];

    const ratingOptions1 = [
        { value: 1, label: "Strong No" },
        { value: 2, label: "No" },
        { value: 3, label: "Neutral" },
        { value: 4, label: "Yes" },
        { value: 5, label: "Strong Yes" },
    ];

    const handleOverallRatingSelect = (value) => {
        setOverallRating(value);
    };




    useEffect(() => {
        if (applicationId && skillId) {
            const fetchScorecardData = async () => {
                try {
                    const res = await dispatch(fetchAppSkillRatingByDetails({
                        baseId: Number(baseId),
                        appId: applicationId,
                        appScoreId: skillId
                    })).unwrap();
                    
                    if (res.status === 200) {
                        setAppScorecardData(res.data);
                        
                        // Populate skills data with fetched ratings and comments
                        const initialSkillsData = {};
                        if (res.data.skillReting && res.data.skillReting.length > 0) {
                            res.data.skillReting.forEach(skillRating => {
                                initialSkillsData[skillRating.skill_id] = {
                                    rating: skillRating.skill_scale,
                                    comment: skillRating.comment || ""
                                };
                            });
                            setSkillsData(initialSkillsData);
                        }
                        
                        setDataFetched(true);
                    }
                } catch (error) {
                    console.error("Error fetching scorecard details:", error);
                    toast.error("Failed to load scorecard data");
                }
            };
            fetchScorecardData();
        }
    }, [applicationId, skillId, baseId, dispatch]);

    return (
        <main className='py-[0px] lg:py-[0px] px-0 lg:px-0 h-full flex'>
            <div className='px-[0px] sm:px-0 lg:px-0 w-full flex justify-center'>
                <div className='w-full max-w-[640px]'>
                    <Link to={`/${baseId}/job/${jobId}/app/${applicationId}/scorecards`}
                        className='flex items-center gap-x-1 w-full mb-4'
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M15 6l-6 6l6 6" />
                        </svg>
                        <span className='text-black-100 text-[13px]'>
                            Back to scorecard
                        </span>
                    </Link>



                    <div className="flex justify-start items-start gap-x-2 mb-4 ml-1">
                        {
                            appScorecardData?.scorecard?.scorecard_colour &&
                            <span className="flex items-center gap-x-3 mt-1">
                                <span
                                    className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                                    style={{ backgroundColor: appScorecardData?.scorecard?.scorecard_colour }}
                                />
                            </span>
                        }

                        {
                            appScorecardData?.scorecard?.scorecard_name &&
                            <div className="flex flex-col gap-[6px] items-start justify-start">
                                <span className="text-[12px] text-[#374151] font-medium leading-4 capitalize">
                                    {appScorecardData?.scorecard?.scorecard_name}
                                </span>
                                {
                                    appScorecardData?.scorecard?.scorecard_description &&
                                    <p className='font-normal text-[#374151] text-[14px] wg-antialiased leading-4'>
                                        {appScorecardData?.scorecard?.scorecard_description}
                                    </p>
                                }

                            </div>
                        }


                    </div>


                    {dataLoading ? (
                        <div className="flex items-center justify-center relative z-50" style={{ height: "100px" }}>
                            <div className="simple-spinner-loader">
                                <span></span>
                            </div>
                        </div>
                    ) : (
                        <>
                            {skills.length > 0 ? (
                                <>
                                    {skills.map((skill) => (
                                        <div key={skill.id} className="rounded-md cursor-pointer ring-1 ring-gray-200 feedback-delete-hover mb-4">
                                            <div className="flex items-center">
                                                <div className="w-[100%] flex flex-col gap-1 px-4 pt-[15px] pb-[15px]">
                                                    <div className="flex justify-start items-center gap-x-2">
                                                        <span className="flex items-center gap-x-3">
                                                            <span
                                                                className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                                                                style={{ backgroundColor: skill.skill_colour }}
                                                            />
                                                        </span>
                                                        <div className="flex gap-x-[6px] items-center">
                                                            <span className="text-[12px] text-[#374151] font-medium leading-4 capitalize">
                                                                {skill.skill_name}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='flex flex-col'>
                                                        <div className='flex items-center gap-2 my-3 flex-wrap'>
                                                            {ratingOptions.map((option) => (
                                                                <RatingButton
                                                                    key={option.value}
                                                                    label={option.label}
                                                                    value={option.value}
                                                                    selectedValue={skillsData[skill.id]?.rating}
                                                                    onClick={(value) => handleRatingSelect(skill.id, value)}
                                                                />
                                                            ))}
                                                        </div>
                                                        {validationErrors[`rating_${skill.id}`] && (
                                                            <p className="text-red-500 text-xs mb-2 mt-[-6px]">Please select a rating</p>
                                                        )}
                                                    </div>

                                                    <AutoResizeTextarea
                                                        value={skillsData[skill.id]?.comment || ""}
                                                        onChange={(e) => handleCommentChange(skill.id, e.target.value)}
                                                        placeholder="Write a comment about this skill"
                                                        isRequired={commentRequiredSkills[skill.id]}
                                                        hasError={validationErrors[`comment_${skill.id}`]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {/* <div className='bg-[#e0e0e0] w-full h-[1px] mt-8 mb-8'></div>
                  <h3 className="text-sm font-medium text-gray-700 mb-2">Overall Assessment</h3> */}




                                    {/* <div className="flex items-center gap-2 my-3 flex-wrap">
                    {ratingOptions1.map((option) => (
                      <RatingButton1
                        key={option.value}
                        label={option.label}
                        value={option.value}
                        selectedValue={overallRating}
                        // onClick={(value) => handleOverallRatingSelect(skill.id, value)}
                        onClick={handleOverallRatingSelect}
                      />
                    ))}
                  </div>
                  {overallRatingError && (
                    <p className="text-red-500 text-xs mb-2 mt-[-6px]">Please select an overall rating</p>
                  )} */}

                                    {/* Overall scorecard comment */}
                                    {/* <div className="">


                    <AutoResizeTextarea1
                      value={overallComment}
                      onChange={handleOverallCommentChange}
                      placeholder="Write an overall comment about this candidate..."
                      hasError={overallCommentError}
                    />
                  </div> */}
                                </>
                            ) : (
                                <div className="text-center py-4">No skills found.</div>
                            )}
                        </>
                    )}

                    <div className='mt-7 pb-4 flex justify-end'>
                        <button
                            className="group inline-flex shrink-0 select-none justify-end items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 transition-colors duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                            type="button"
                            onClick={handleSaveScorecard}
                            disabled={savingData}
                        >
                            <div className='flex items-center gap-[6px]'>
                                Update scorecard
                                {savingData && (
                                    <div className="simple-spinner">
                                        <span></span>
                                    </div>
                                )}
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default JobSkillScorecardEdit